module.exports = __webpack_public_path__ + "img/contrastLogo.e125303f.png";